import React, { useState, useEffect, createRef } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import PlaceDetailsShimmer from "./PlaceDetailsShimmer";

import PlaceDetails from "./PlaceDetails";

const List = ({ places, isLoading, type, childClicked }) => {
  const [elRefs, setElRefs] = useState([]);

  useEffect(() => {
    setElRefs((refs) =>
      Array(places?.length)
        .fill()
        .map((_, i) => refs[i] || createRef())
    );
  }, [places]);

  return (
    <div>
      {isLoading ? (
        <div className="h-[72vh] overflow-y-scroll overflow-x-hidden  m-10 ml-7">
        {[1, 2, 3, 4, 5].map((item) => (
          <PlaceDetailsShimmer key={item} />
        ))}
      </div>
        
      ) : (
        <div className="space-y-4  text-sm font-normal ml-16">
          {places?.length && (
            <div className="-ml-7">
              Displaying {places.length}{" "}
              {type.charAt(0).toUpperCase() + type.slice(1)} around you
            </div>
          )}
          <div className="h-[72vh] overflow-y-scroll overflow-x-hidden  m-10 -ml-7">
            <Grid container spacing={3}>
              {places?.map((place, i) => (
                <>
                  <Grid ref={elRefs[i]} item key={i} xs={12}>
                    <PlaceDetails
                      place={place}
                      selected={Number(childClicked) === i}
                      refProp={elRefs[i]}
                    />
                  </Grid>
                  {i < places.length - 1 && (
                    <div className="w-[95%] border-b-2 border-gray-200" />
                  )}
                </>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
};

export default List;
